import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";

export const GuidelinesLink = ({ className = "", testid = "artwork-guidelines-link" }) => (
  <Link to="/artwork-guidelines" data-testid={testid} className={`inline-flex items-center gap-1 text-xs text-[#22c3d6] hover:text-white hover:underline underline-offset-2 ${className}`}>
    <BookOpen size={12} />See Artwork Guidelines
  </Link>
);
